module.exports = __webpack_public_path__ + "img/grid_2.e281b5dd.svg";